import { format } from '@flasd/whatsapp-formatting';
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['strong', 'b', 'em', 'i', 's', 'code', 'br', 'a'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];
const LINK_PATTERN = /(https?:\/\/[^\s<]+|www\.[^\s<]+|[\w.+-]+@[\w.-]+\.[a-zA-Z]{2,})/g;

function createLink(value) {
  const link = document.createElement('a');
  const isEmail = value.includes('@') && !value.startsWith('http');
  const href = isEmail
    ? `mailto:${value}`
    : value.startsWith('www.')
      ? `https://${value}`
      : value;

  link.href = href;
  link.textContent = value;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  return link;
}

function linkify(html) {
  const template = document.createElement('template');
  template.innerHTML = html;
  const walker = document.createTreeWalker(
    template.content,
    NodeFilter.SHOW_TEXT
  );
  const textNodes = [];

  while (walker.nextNode()) {
    const node = walker.currentNode;

    if (!['A', 'CODE'].includes(node.parentElement && node.parentElement.tagName)) {
      textNodes.push(node);
    }
  }

  textNodes.forEach(node => {
    const text = node.textContent;
    const matches = [...text.matchAll(LINK_PATTERN)];

    if (!matches.length) {
      return;
    }

    const fragment = document.createDocumentFragment();
    let offset = 0;

    matches.forEach(match => {
      fragment.appendChild(document.createTextNode(text.slice(offset, match.index)));
      fragment.appendChild(createLink(match[0]));
      offset = match.index + match[0].length;
    });

    fragment.appendChild(document.createTextNode(text.slice(offset)));
    node.replaceWith(fragment);
  });

  return template.innerHTML;
}

export function formatWhatsAppText(value) {
  const formatted = format(String(value || ''));
  const sanitized = DOMPurify.sanitize(formatted, {
    ALLOWED_TAGS,
    ALLOWED_ATTR
  });

  return DOMPurify.sanitize(linkify(sanitized), {
    ALLOWED_TAGS,
    ALLOWED_ATTR
  });
}
